import {catalogueProductFromRow,createCatalogueProduct} from './product-catalogue.js';

export const PRODUCT_CATALOGUE_CACHE_ENTITY='product_catalogue_item';

export const DEFAULT_PRODUCT_CATALOGUE_ROWS=Object.freeze([
  Object.freeze({code:'pork_loin',category_key:'pork',display_name_pl:'Schab',display_name_en:'Pork loin',sort_order:10,catalogue_version:1,is_active:true}),
  Object.freeze({code:'pork_belly',category_key:'pork',display_name_pl:'Boczek',display_name_en:'Pork belly',sort_order:20,catalogue_version:1,is_active:true}),
  Object.freeze({code:'pork_ham',category_key:'pork',display_name_pl:'Szynka wieprzowa',display_name_en:'Pork ham',sort_order:30,catalogue_version:1,is_active:true}),
  Object.freeze({code:'pork_neck',category_key:'pork',display_name_pl:'Karkówka',display_name_en:'Pork neck',sort_order:40,catalogue_version:1,is_active:true}),
  Object.freeze({code:'beef_brisket',category_key:'beef',display_name_pl:'Mostek wołowy',display_name_en:'Beef brisket',sort_order:110,catalogue_version:1,is_active:true}),
  Object.freeze({code:'beef_ribs',category_key:'beef',display_name_pl:'Żeberka wołowe',display_name_en:'Beef ribs',sort_order:120,catalogue_version:1,is_active:true}),
  Object.freeze({code:'chicken',category_key:'poultry',display_name_pl:'Kurczak',display_name_en:'Chicken',sort_order:210,catalogue_version:1,is_active:true}),
  Object.freeze({code:'turkey',category_key:'poultry',display_name_pl:'Indyk',display_name_en:'Turkey',sort_order:220,catalogue_version:1,is_active:true}),
  Object.freeze({code:'salmon',category_key:'fish',display_name_pl:'Łosoś',display_name_en:'Salmon',sort_order:310,catalogue_version:1,is_active:true}),
  Object.freeze({code:'trout',category_key:'fish',display_name_pl:'Pstrąg',display_name_en:'Trout',sort_order:320,catalogue_version:1,is_active:true}),
  Object.freeze({code:'sausage',category_key:'sausage',display_name_pl:'Kiełbasa',display_name_en:'Sausage',sort_order:410,catalogue_version:1,is_active:true}),
  Object.freeze({code:'cheese',category_key:'cheese',display_name_pl:'Ser',display_name_en:'Cheese',sort_order:510,catalogue_version:1,is_active:true}),
  Object.freeze({code:'vegetables',category_key:'vegetables',display_name_pl:'Warzywa',display_name_en:'Vegetables',sort_order:610,catalogue_version:1,is_active:true}),
  Object.freeze({code:'other_product',category_key:'other',display_name_pl:'Inny produkt',display_name_en:'Other product',sort_order:710,catalogue_version:1,is_active:true})
]);

function localeKey(locale){
  return String(locale||'pl').toLowerCase().startsWith('en')?'en':'pl';
}

function normaliseItem(value={}){
  if(value?.labels?.pl&&value?.labels?.en){
    return createCatalogueProduct({
      code:value.code,
      categoryKey:value.categoryKey,
      displayNamePl:value.labels.pl,
      displayNameEn:value.labels.en,
      sortOrder:value.sortOrder,
      catalogueVersion:value.catalogueVersion
    });
  }
  const legacy=catalogueProductFromRow(value,{locale:'pl'});
  return createCatalogueProduct({
    code:legacy.code,
    categoryKey:legacy.categoryKey,
    displayNamePl:legacy.labels.pl,
    displayNameEn:legacy.labels.en,
    sortOrder:legacy.sortOrder,
    catalogueVersion:legacy.catalogueVersion
  });
}

function mapItems(items,{locale='pl'}={}){
  const lang=localeKey(locale);
  return Object.freeze((items||[])
    .filter(item=>item?.is_active!==false)
    .map(normaliseItem)
    .sort((a,b)=>a.sortOrder-b.sortOrder||a.labels[lang].localeCompare(b.labels[lang],lang))
    .map(item=>Object.freeze({...item,displayName:item.labels[lang]})));
}

export function createProductCatalogueService({
  repository,
  remote=null,
  diagnostics=null,
  isOnline=()=>globalThis.navigator?.onLine!==false
}={}){
  if(!repository?.list||!repository?.put)throw new TypeError('repository with list/put is required');
  if(remote!=null&&typeof remote?.list!=='function')throw new TypeError('Product catalogue remote with list() is required');

  async function cachedItems(){
    const rows=await repository.list(PRODUCT_CATALOGUE_CACHE_ENTITY);
    return (rows||[])
      .map(row=>row?.catalogueItem??row?.catalogueRow)
      .filter(Boolean);
  }

  async function cache(items){
    for(const input of items||[]){
      const item=normaliseItem(input);
      await repository.put(PRODUCT_CATALOGUE_CACHE_ENTITY,{id:item.code,catalogueItem:item});
    }
  }

  async function load({locale='pl',refresh=true}={}){
    if(refresh&&remote&&isOnline()){
      try{
        const items=await remote.list();
        if(items?.length){
          await cache(items);
          return Object.freeze({source:'remote',items:mapItems(items,{locale})});
        }
      }catch(error){
        try{diagnostics?.capture?.('journal.product-catalogue',error);}catch{}
      }
    }
    const cached=await cachedItems();
    if(cached.length)return Object.freeze({source:'cache',items:mapItems(cached,{locale})});
    return Object.freeze({source:'fallback',items:mapItems(DEFAULT_PRODUCT_CATALOGUE_ROWS,{locale})});
  }

  return Object.freeze({load});
}
